export class Tax {
  id?: number;
  nameKey?: string;
  value?: string;
  calculationMethod?: string;
  offerId?: number;
  transporterId?: number;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }

  public serialize(): any {
    return this;
  }
}
